import { ACTIONS } from '../actions';
import { pluginKey as typeAheadPluginKey } from '../key';
export var clearListError = function clearListError() {
  return function (_ref) {
    var tr = _ref.tr;
    tr.setMeta(typeAheadPluginKey, {
      action: ACTIONS.CLEAR_LIST_ERROR,
      params: {
        errorInfo: null
      }
    });
    return tr;
  };
};